import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {AssetService} from "../../services/AssetService";
import { EmployeeService } from "../../services/EmployeeService";

export class ReportEmployeeWorkHoursModel {
    static $inject = ['$q','FileSaver','Blob','EmployeeService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    numberOfDays:number = 7;
    totalCount:number = 0;
    constructor(public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public employeeService:EmployeeService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
    }
    getReport(): ng.IPromise<any>{
        return this.employeeService.getReport(this.numberOfDays).then((data) => {
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'Employee_Work_Hours.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("getReport err:"+exc);
            });
        return this.$q.when();
    }
}
